import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["icon", "className"];
import { jsx } from 'react/jsx-runtime';
import { BoxBlue100 } from '@box/blueprint-web-assets/tokens/tokens';
import clsx from 'clsx';
import { forwardRef, createElement } from 'react';
import styles from './interactive-icon.module.js';
var InteractiveIcon = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  var icon = props.icon,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded);

  return jsx("button", _objectSpread(_objectSpread({}, rest), {}, {
    ref: forwardedRef,
    className: clsx(styles.interactiveIcon, className),
    type: "button",
    children: /*#__PURE__*/createElement(icon, {
      color: BoxBlue100,
      role: 'presentation'
    })
  }));
});
InteractiveIcon.displayName = 'InteractiveIcon';
export { InteractiveIcon };